import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  Grid,
  ThemeProvider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import LoginHeader from "../components/Login/LoginHeader";
import LoginInfo from "../components/Login/LoginInfo";
import LoginBox from "../components/Login/LoginBox";
import ForgotPassword from "../components/Login/ForgotPassword";
import LandingBackground from "../components/Landing/LandingBackground";
import LandingFooter from "../components/Landing/LandingFooter";

import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/firebase";
import { loginTheme } from "../styles/globalStyles";

const LoginPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [forgotOpen, setForgotOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    if (name === "email") setEmailError("");
    if (name === "password") setPasswordError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError("");
    setPasswordError("");

    if (!formData.email) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    if (!formData.password) {
      setPasswordError("Password is required.");
      return;
    }

    try {
      await signInWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );

      navigate("/", { replace: true }); // 👈 THIS IS THE FIX

    } catch (err) {
      if (err.code === "auth/user-not-found") {
        setEmailError("No account found with this email.");
      } else if (err.code === "auth/wrong-password") {
        setPasswordError("Incorrect password.");
      } else {
        setPasswordError("Login failed. Please try again.");
      }
    }
  };

  return (
    <ThemeProvider theme={loginTheme}>
      <CssBaseline />

      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <LandingBackground />

        <Box sx={{ position: "relative", zIndex: 1 }}>
          <LoginHeader />

          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ px: 3, pb: 10 }}
          >
            <Grid container maxWidth="lg" spacing={8} alignItems="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <LoginInfo />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <LoginBox
                  formData={formData}
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                  emailError={emailError}
                  passwordError={passwordError}
                  onForgotPasswordClick={() => setForgotOpen(true)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mt: "auto", zIndex: 1 }}>
          <LandingFooter />
        </Box>

        <ForgotPassword
          open={forgotOpen}
          onClose={() => setForgotOpen(false)}
        />
      </Box>
    </ThemeProvider>
  );
};

export default LoginPage;
